import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfoTooltipComponent } from '@ui-kit/miscs';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'radio-button-fc',
    standalone: true,
    imports: [RadioButtonModule, ReactiveFormsModule, TranslateModule, InfoTooltipComponent],
    templateUrl: './radio-button-fc.component.html',
    styleUrl: './radio-button-fc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonFcComponent {
    name = input.required<string>();
    control = input.required<FormControl>();
    options = input.required<
        {
            id: string;
            label: string;
            value: any;
            disabled?: boolean;
            tooltipText?: string;
        }[]
    >();

    inline = input<boolean>(true);

    onClick = output<void>();
}
